import axios from "axios";

const baseURL = process.env.VUE_APP_API_BASE_URL;
export default axios.create({
    baseURL,
}); 

// const baseURL = "https://190.223.56.84/api";

// // cviera dev
// // const baseURL = "http://localhost:49684/api";

// export default axios.create({
//     baseURL,
// });